/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import {
	productDetailsNameSX,
	familyDetailsSX,
} from '@/components/blocks/ProductDetails/styles/name';
import { CategoryType } from '@/data/types/Category';
import { ProductType } from '@/data/types/Product';
import { getProductDisplayInfo } from '@/utils/getProductDisplayInfo';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

interface BundleDetailsDisplayProps {
	product?: ProductType;
	category?: CategoryType;
}

export const BundleDetailsDisplay: FC<BundleDetailsDisplayProps> = ({ product, category }) => {
	const { name } = getProductDisplayInfo(product, product);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const categoryName = category?.name;

	return (
		<Stack>
			{!isMobile && categoryName ? (
				<Box component={'span'} sx={familyDetailsSX}>
					{categoryName}
				</Box>
			) : null}
			{name ? (
				<Typography variant="h4AsH1" sx={productDetailsNameSX}>
					{name}
				</Typography>
			) : null}
		</Stack>
	);
};
